import {createContext, useReducer} from 'react';

const state = {
    active: false,
}
export const LoaderContext = createContext(null);
export const LoaderDispatch = createContext(null);
export function LoaderProvider({children}) {
    const [config, dispatch] = useReducer(
        LoaderReducer,
        state
    );
    return (
        <LoaderContext.Provider value={config}>
            <LoaderDispatch.Provider value={dispatch}>
                {children}
            </LoaderDispatch.Provider>
        </LoaderContext.Provider>
    )
}

function LoaderReducer(config, action) {
    //console.log('loader', action);
    switch (action.type) {
        case 'activate' :
            return {...state , active: true};
        case 'deactivate' :
            return {...state , active: false};
        default:
            throw Error('Unknown action: ' + action.type);
    }
}